import { render } from "./EventRow.vue?vue&type=template&id=44096773&scoped=true"
import script from "./EventRow.vue?vue&type=script&lang=js"
export * from "./EventRow.vue?vue&type=script&lang=js"

import "./EventRow.vue?vue&type=style&index=0&id=44096773&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44096773"]])

export default __exports__